// isMobileCheck.utility.ts

import { environment } from '@env/environment';

export function isMobileView() {
  return window.innerWidth < (environment?.mobileBreakpoint || 768);
}

export function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor;
  if (/android/i.test(userAgent)) {
    return true;
  }
  return /iPad|iPhone|iPod/.test(userAgent) && !window['MSStream'];
}
